<template>
    <div class="wrapper success_base">
        <img src="../../assets/image/secondary/notice.jpg" style="width: 100%;height: auto">
    </div>
</template>

<script>

    import _wx from "@/common/_wx";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import cache_url from "@/cache/cache_url";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _copyUrl from "@/common/_copyUrl";
    import lib_clue from "@/libs/lib_clue";

    export default {
        name: "success_base",

        data() {
            return {
                tid: 1, // 5是非汽车行业
            }
        },

        created() {
            document.title = '2024年5月晋城车展';

        },
        methods: {

        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/secondary/base.less";
    @import "../../assets/style/autoshow/form.less";
    // form
    @import "../../assets/style/common/successful.less"; // 成功
    /deep/ .el-divider--horizontal {
        margin: 10px 0;
    }
</style>
